import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { useTranslation } from 'react-i18next';

const Home: React.FC = () => {
    const { user } = useUser();  // Access user from global context
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            navigate('/home');  // Redirect to UserHome if logged in
        } else {
            navigate('/welcome');  // Redirect to About if not logged in
        }
    }, [user, navigate]);

    return <div>{t('home.loading')}</div>;  // Render loading or other UI as needed
};

export default Home;
